import { useState } from "react";
import { PanelShell, tokens } from "../index";
import { compatibleKeys, parseCamelot, CAMELOT_HOURS } from "../djoidLibraryModel";

/**
 * Crates module — an interactive Camelot wheel explorer: pick a key and see its harmonically
 * compatible neighbours, computed by the shared djoid library model (the same logic that drives
 * smart crates).
 *
 * @returns A Camelot wheel panel with the selected key's compatible neighbours, plus a smart
 *   crates info panel.
 */
export function CratesModule() {
  const [key, setKey] = useState("8A");
  const parsed = parseCamelot(key);
  const compat = parsed ? compatibleKeys(parsed) : [];
  const hours = Array.from({ length: CAMELOT_HOURS }, (_, i) => i + 1);
  return (
    <>
      <PanelShell title="Camelot harmonic explorer">
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 12 }}>
          {hours.map((h) => (["A", "B"] as const).map((lane) => {
            const k = `${h}${lane}`;
            const isSel = k === key;
            const isCompat = compat.includes(k);
            return (
              <button key={k} onClick={() => setKey(k)} style={{
                width: 40, padding: "6px 0", fontSize: 12, cursor: "pointer", borderRadius: 4,
                background: isSel ? tokens.color.accent : isCompat ? tokens.color.surface2 : "transparent",
                color: isSel ? "#12100a" : isCompat ? tokens.color.accent : tokens.color.muted,
                border: `1px solid ${isSel || isCompat ? tokens.color.accentDim : tokens.color.border}`,
                fontWeight: isSel ? 700 : 400,
              }}>{k}</button>
            );
          }))}
        </div>
        <div style={{ fontSize: 12, color: tokens.color.textDim }}>
          Mixing from <strong style={{ color: tokens.color.accent }}>{key}</strong> — harmonic neighbours:{" "}
          {compat.filter((k) => k !== key).join(", ")}. Smart crates filter your library by these.
        </div>
      </PanelShell>
      <PanelShell title="Smart crates" style={{ marginTop: 12 }}>
        <p style={{ margin: 0, color: tokens.color.textDim, fontSize: 13 }}>
          Rule-based crates driven by BPM, Camelot, energy, danceability and tags — evaluated by
          the shared library model, identical on web and desktop.
        </p>
      </PanelShell>
    </>
  );
}
